import React from 'react'
import Header from '../Header'
import Footer from '../Footer'
import { useDarkMode } from '../DarkModeProvider'
import {
  ContactFormContainer,
  ContactFormProvider
} from '../ContactFormProvider'

type LayoutProps = {
  children: React.ReactNode
}

export default function Layout({ children }: LayoutProps) {
  const { isDarkMode } = useDarkMode()

  return (
    <div id="wrapper" className={`relative ${isDarkMode ? 'dark' : ''}`}>
      <ContactFormProvider>
        <Header />
        <ContactFormContainer />
        {children}
        <Footer />
      </ContactFormProvider>
    </div>
  )
}
